import Vue from "vue";
import App from "./App";
import router from "./router";
import i18n from "./i18n";
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = true;

/* eslint-disable no-new */
new Vue({
	el: "#app",
	replace: false,
	router,
	i18n,
	render: h => h(App),
	data: {
		// apiURL: 'http://dev-api.softcare.io/api/v1/' + i18n.locale + '/cms'
		apiURL: "http://api.softcare.io/api/v1/" + i18n.locale + "/cms"
	}
});

Vue.use(VueAnalytics, {
	id: "UA-108021089-1",
	router
});



// WEBPACK FOOTER //
// ./src/main.js